import MenuDetalhes from "ui/components/Menu/MenuDetalhes";
import {
  TabsDetalheAssembleia,
  TabsDetalheAssembleiaRoutes,
} from "../../typings";
import { VotacaoDetalhes } from "core/features/assembleia/typings";

interface MenuDetalhesRouteProps {
  selectedMenuOption: string;
  route: {
    params: {
      id: string;
    };
  };
  data: VotacaoDetalhes | undefined;
  handleChangeMenu: (tab: string) => void;
  rounded?: boolean;
  shadow?: boolean;
}

export default function MenuDetalhesRoute({
  selectedMenuOption,
  route,
  data,
  handleChangeMenu,
  rounded,
  shadow,
}: MenuDetalhesRouteProps) {
  return (
    <MenuDetalhes
      disabledOptions={
        !route.params.id
          ? [
              TabsDetalheAssembleiaRoutes.Participantes,
              TabsDetalheAssembleiaRoutes.Perguntas,
              TabsDetalheAssembleiaRoutes.Procuracoes,
              TabsDetalheAssembleiaRoutes.Relatorio,
              TabsDetalheAssembleiaRoutes.Resultado,
              TabsDetalheAssembleiaRoutes.Video,
            ]
          : !data?.webinarId
          ? [TabsDetalheAssembleiaRoutes.Video]
          : []
      }
      options={TabsDetalheAssembleia}
      selectedOption={selectedMenuOption as TabsDetalheAssembleiaRoutes}
      onChangeOption={(tab) => {
        handleChangeMenu(tab);
      }}
      rounded={rounded}
      shadow={shadow}
    />
  );
}
